import { render } from "./HomeView.vue?vue&type=template&id=5e0efbc5&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=5e0efbc5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/wakeup/wakeup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0efbc5"]])

export default __exports__